/**
 * Main page
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id     = 'pMain',
    Page   = require('stb-component-page'),
    page   = new Page({$node: document.getElementById(id)}),
    app    = require('mag-app'),
    keys   = require('stb-keys'),
    Menu   = require('../modules/menu'),
    PlayerPanel = require('../modules/player.panel'),
    runner = require('../modules/runner'),
    $title = document.getElementById('contentTitle'),
    $mediaInfo = {
        codec: document.getElementById('codecInfo'),
        lang: document.getElementById('langInfo')
    },
    $img = document.getElementById('canvas'),
    config = {
        rotate: 0,
        random: false,
        slideShow: {
            active: false,
            timeout: 0,
            current: 0,
            modes: [3, 5, 7]

        }
    },
    timer = {
        progress: null,
        contentInfo: null,
        panelHide: null

    },
    buttons = {},
    currentPlayIntent,
    player,
    mainMenu;

/* eslint no-use-before-define:0 */
//

buttons.slideshow = {
    icon: 'theme-icon theme-icon-slideshow',
    title: gettext('Slide show') + ': 3 ' + gettext('sec'),
    buttonName: 'slideShow',
    click: changeSlideShowMode
};


buttons.mode = {
    icon: 'theme-icon theme-icon-repeat',
    title: gettext('Repeat'),
    buttonName: 'mode',
    click: function () {
        config.random = !config.random;
        if ( config.random ) {
            mainMenu.links.mode.links.$text.innerText = gettext('Random');
            mainMenu.links.mode.links.$icon.className = 'theme-icon theme-icon-shuffle';
        } else {
            mainMenu.links.mode.links.$text.innerText = gettext('Repeat');
            mainMenu.links.mode.links.$icon.className = 'theme-icon theme-icon-repeat';
        }
    }
};


page.add(mainMenu = new Menu({
    $node: document.getElementById('pMainMenu'),
    focusIndex: 1,
    size: 2,
    propagate: false,
    data: [buttons.mode, buttons.slideshow]
}));


mainMenu.addListener('keydown', function ( event ) {
    if ( event.code === keys.up ) {
        player.focus();
    }
});


page.add(
    player = new PlayerPanel({
        $node: document.getElementById('pMainPlayerPanel'),
        onPlay: playPause,
        onPrevNext: function ( event ) {
            switch ( event.direction ) {
                case keys.right:
                    nextPrevContent(true);
                    break;
                case keys.left:
                    nextPrevContent(false);
                    break;
            }
        },
        onRotate: rotate,
        events: {
            keydown: function ( event ) {
                if ( event.code === keys.down ) {
                    mainMenu.focus();
                }
            }
        }
    })
);
mainMenu.init({
    data: [buttons.mode, buttons.slideshow],
    size: 2,
    focusIndex: 1
});
resetInfo();


page.addListener('show', function () {
    player.focus();
});


//core.events = {};

core.addListener('intent', function ( intent, callback ) {
    debug.log('player catch intent', 'blue');

    switch ( intent.action ) {
        case 'play':
            startPlay(intent, callback);
            break;
    }
});


function rotate ( fnConfig ) {
    var styleString;

    switch ( fnConfig.direction ) {
        case keys.right:
            config.rotate += 90;
            break;
        case keys.left:
            config.rotate -= 90;
            break;
    }
    styleString = 'rotate(' + config.rotate + 'deg)';
    $img.style.webkitTransform = styleString;
    $img.style.transform = styleString;
    $img.style.height = app.metrics.height + 'px';

}

function startPlay ( intent, callback ) {
    // error
    if ( !intent.data /*|| !intent.data.uri*/ ) {
        callback(true, null);

        return;
    }

    console.log(intent, 'intent');

    app.currentIntent = currentPlayIntent = intent;
    resetInfo();

    if ( !intent.context ) {
        app.route(app.pages.main);
        player.focus();
    }
    $title.innerText = intent.data.title || intent.data.uri;

    intent.once('start', function () {
        // hidePanel(PANEL_HIDE_TIMEOUT);
    });


    if ( player.buttons.$focusItem.data.disabled ) {
        player.buttons.focusIndex(2);
    }

    if ( intent.data.totalCount && intent.data.currentPosition ) {
        player.$rightText.innerText = intent.data.currentPosition + '/' + intent.data.totalCount;
    }

    runner.show({
        uri: intent.data.uri,
        onerror: function () {
            core.notify({
                title: 'Error opening ' + (intent.data.title || intent.data.uri),
                icon: 'alert',
                type: 'error',
                timeout: 3000
            });
        }
    });
    if ( callback ) {
        callback(false, {});
    }
}

page.addListener('keydown', function ( event ) {

    clearTimeout(timer.panelHide);
    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.clear);
            break;
        case keys.info:
            app.route(app.pages.clear);
            break;
    }
});

app.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.forward:
        case keys.channelNext:
        case keys.pageDown:
            nextPrevContent(true);
            break;
        case keys.rewind:
        case keys.channelPrev:
        case keys.pageUp:
            nextPrevContent(false);
            break;
        case keys.playPause:
            playPause();
            break;
        case keys.exit:
            resetInfo();
            break;
    }
});

app.nextPrevContent = function ( state ) {
    if (currentPlayIntent.events.next || currentPlayIntent.events.prev ) {
        nextPrevContent(state);
    }
};

function changeSlideShowMode () {
    config.slideShow.current++;

    if ( config.slideShow.current > config.slideShow.modes.length - 1 ) {
        config.slideShow.current = 0;
    }

    mainMenu.links.slideShow.links.$text.innerText =
        gettext('Slide show') + ': ' + config.slideShow.modes[config.slideShow.current] + ' ' + gettext('sec');

}

function playPause () {
    config.slideShow.active = !config.slideShow.active;

    if ( config.slideShow.active ) {
        player.$playPauseBtn.className = 'theme-icon theme-icon-pause';
        config.slideShow.timeout = setTimeout(setSlideShowTimeout, config.slideShow.modes[config.slideShow.current] * 1000);
    } else {
        player.$playPauseBtn.className = 'theme-icon theme-icon-play';
        clearTimeout(config.slideShow.timeout);
    }

    function setSlideShowTimeout () {
        nextPrevContent(true);
        config.slideShow.timeout = setTimeout(setSlideShowTimeout, config.slideShow.modes[config.slideShow.current] * 1000);
    }

}

/**
 * Send initiator app to get next/prev content.
 *
 * @param {boolean} state - state to get data: true - next, false - prev content
 */
function nextPrevContent ( state ) {
    resetInfo();


    if ( state && currentPlayIntent.events.next ) {
        currentPlayIntent.emit('next', {random: config.random});
    } else if ( !state && currentPlayIntent.events.prev ) {
        currentPlayIntent.emit('prev');
    }
}

function resetInfo () {
    config.rotate = 0;
    $img.style.webkitTransform = '';
    player.$rightText.innerText = '';
    $img.style.background = 'transparent';
    $mediaInfo.codec.src = '';
    $mediaInfo.lang.innerText = '';
}

app.addListener('close', function () {
    //
    clearTimeout(config.slideShow.timeout);
    config.slideShow.active = false;
    player.$playPauseBtn.className = 'theme-icon theme-icon-play';

});

core.addListener('hide', function () {
    debug.log('Player hiding', 'red');
    resetInfo();
    if ( currentPlayIntent ) {
        // emit to initiate app that player is hide
        currentPlayIntent.emit('hide');
    }
    clearTimeout(config.slideShow.timeout);
    config.slideShow.active = false;
    player.$playPauseBtn.className = 'theme-icon theme-icon-play';

});
//
// function hidePanel ( sec ) {
//     sec = sec || 5;
//
//     clearTimeout(timer.panelHide);
//     timer.panelHide = setTimeout(function () {
//         app.route(app.pages.clear);
//     }, 1000 * sec);
// }


app.ready();

// public
module.exports = page;
